module.exports = __webpack_public_path__ + "media/images/icon-user-d6623828853fc818bb9dfd4b4ee8b0ac.svg";